// extracted by mini-css-extract-plugin
export default {"recommended":"recommended_recommended__Js0VY","head":"recommended_head__TfIub"};